import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import InputGroupV2 from '../InputGroupV2';
import NumberFormat from 'react-number-format';

const InputFormatV2 = ({
  value,
  label,
  title,
  placement,
  placeholder,
  useTooltip,
  onChange,
  fullWidth,
  name,
  isRequired,
  error,
  helperText,
  rows,
  multiline,
  inputProps,
  disabled,
  classNameInputGroup,
  type,
  min,
  step,
  showHelperText,
  format,
  mask,
  showInputGroup,
}) => {
  const defaultHelperText = helperText ? helperText : 'O campo é obrigatório';

  const numberField = (
    <NumberFormat
      customInput={TextField}
      format={format}
      fullWidth={fullWidth}
      error={error}
      helperText={error || showHelperText ? defaultHelperText : ''}
      name={name}
      onChange={onChange}
      placeholder={placeholder ? placeholder : label}
      value={value}
      rows={rows}
      multiline={multiline}
      InputProps={inputProps}
      disabled={disabled}
      type={type}
      min={min}
      step={step}
      mask={mask}
      sx={{
        '& .MuiInputBase-root': {
          bgcolor: disabled ? 'transparent' : 'background.paper',
        },
        '& .MuiOutlinedInput-input': {
          color: 'text.primary',
        },
      }}
    />
  );

  if (!showInputGroup) return numberField;

  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={isRequired}
      className={classNameInputGroup}
    >
      {numberField}
    </InputGroupV2>
  );
};

InputFormatV2.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  isRequired: PropTypes.any,
  multiline: PropTypes.bool,
  placeholder: PropTypes.string,
  placement: PropTypes.string,
  rows: PropTypes.number,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  value: PropTypes.string,
  inputProps: PropTypes.object,
  disabled: PropTypes.bool,
  classNameInputGroup: PropTypes.string,
  type: PropTypes.string,
  min: PropTypes.string,
  step: PropTypes.string,
  showHelperText: PropTypes.bool,
  format: PropTypes.string,
  mask: PropTypes.string,
  showInputGroup: PropTypes.bool,
};

InputFormatV2.defaultProps = {
  error: false,
  fullWidth: true,
  helperText: '',
  label: '',
  multiline: false,
  placement: 'top',
  rows: 1,
  title: '',
  useTooltip: false,
  isRequired: false,
  value: '',
  inputProps: {},
  disabled: false,
  classNameInputGroup: '',
  type: 'text',
  placeholder: null,
  onChange: () => {},
  name: '',
  min: null,
  step: null,
  showHelperText: false,
  format: '',
  mask: '',
  showInputGroup: true,
};

export default InputFormatV2;
